import { all } from 'redux-saga/effects';
import userAccountSaga from '../../../../pages/authentication/data-access/+state/account.saga';
import projectListSaga from '../../../../pages/project-management/project-list/data-access/+state/project-list.saga';
import createProjectSaga from '../../../../pages/project-management/create-project/data-access/+state/project-create.saga';

function* rootSaga() {
  yield all([userAccountSaga(), projectListSaga(), createProjectSaga()]);
}
export default rootSaga;
